(function () {
	const initProductAccordion = () => {
		$('.about__accordion-toggle')
			.off('click.rebxAccordion')
			.on('click.rebxAccordion', function () {
				const $toggle = $(this);
				const $item = $toggle.closest('.about__accordion-item');
				const $panel = $toggle.siblings('.about__accordion-description');

				if (!$toggle.hasClass('active')) {
					$toggle.addClass('active').attr('aria-expanded', 'true');
					$item.addClass('is-open');
					$panel.stop().slideDown(300);
				} else {
					$toggle.removeClass('active').attr('aria-expanded', 'false');
					$item.removeClass('is-open');
					$panel.stop().slideUp(300);
				}
			});
	};

	document.addEventListener('shopify:section:load', function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
